<template>
  <div>
    <q-dialog :visible="isVisible" title="渲染" width="50%" :innerScroll="false" :showFooter="false" @close="onCancel">
      <div v-loading="loading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading">
        <div class="header">
          <div>
            <el-button
              type="primary"
              size="mini"
              @click="importRender"
              v-if="!renderImportShow"
              v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$renderingImportBth'"
              >渲染上传
            </el-button>
            <el-button
              type="primary"
              size="mini"
              @click="importModel"
              v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$renderingImportBth'"
              >模型上传
            </el-button>
          </div>
          <div>
            <span>需上传渲染产品：</span>
            <el-button type="text" @click="getProductList">点击查看</el-button>
            <span style="margin-left: 20px">渲染上传规则：</span>
            <el-popover placement="left-start" title="" width="500" trigger="click">
              <div class="popoverBOx">
                <h4>1、上传文件夹限制：</h4>
                <p>①上传文件夹名称必须与需上传的“产品名称”一致；</p>
                <p>②同时上传多个产品，上传文件夹名称请用“&”符号将多个产品名称组合在一起；</p>
                <p>③上传文件夹下的二级文件夹类型必须为“大片”、"小片”、“特写”、“退底”和“通道”，仅有任一类型也可上传；</p>
                <h4>2、上传说明：</h4>
                <p>①当SKU维护了“渲染计划"中”渲染类型”，则表示此SKU涉及产品必须上传渲染图；</p>
                <p>②当维护了的“渲染类型”的产品全部上传后，渲染节点自动完成;</p>
                <h4>3、上传类型说明:</h4>
                <p>①首：第一次上传对应产品渲染文件夹;</p>
                <p>②改色差/改工艺：上传文件夹以及里面图片的名称和数量需与上次上传一致；</p>
                <p>③补图：上传上传文件夹以及里面图片的名称需与上次上传不一致；</p>
              </div>
              <el-button type="text" slot="reference">点击查看</el-button>
            </el-popover>
          </div>
        </div>
        <el-table
          :data="tableData"
          v-if="tableReload"
          border
          height="320px"
          :header-cell-style="{
            backgroundColor: '#FAFAFA',
            textAlign: 'center',
          }"
          :cell-style="{ textAlign: 'center' }"
          style="width: 100%"
        >
          <el-table-column prop="productName" label="文件名" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="updateTime" label="更新时间" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="bookTime" label="操作" :show-overflow-tooltip="true">
            <template slot-scope="{ row }">
              <el-button type="text" @click="download(row)" v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$renderingDownload'"
                >下载</el-button
              >
            </template>
          </el-table-column>
          <el-table-column width="55" label="" type="expand">
            <template slot-scope="scope">
              <el-table :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }" :data="scope.row.detailInfoList" border>
                <el-table-column prop="categoryType" label="类型" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="categoryNum" label="数量" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="updateTime" label="更新时间" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="updatePerson" label="操作人" :show-overflow-tooltip="true"></el-table-column>
              </el-table>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </q-dialog>

    <!-- 渲染上传 -->
    <q-dialog :visible="isVisibleImport" title="渲染上传" width="780px" :innerScroll="false" :showFooter="false" @cancel="onCancelImport" @close="onCancelImport">
      <div v-loading="loading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading">
        <el-form :model="requestParam" :rules="rules" ref="requestParam" label-width="140px" class="content">
          <el-row>
            <el-col :span="24" v-if="allFilesVerified">
              <el-form-item label="类型" prop="businessType">
                <el-select v-model="requestParam.businessType" size="mini">
                  <el-option label="首次" :value="1" v-if="isFirst"></el-option>
                  <template v-else>
                    <el-option label="补图" :value="2"></el-option>
                    <el-option label="改工艺" :value="3"></el-option>
                    <el-option label="改色差" :value="4"></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24" align="left">
              <el-form-item label="附件:">
                <el-upload
                  class="upload-demo"
                  accept=".jpg,.jpeg,.png"
                  ref="upload"
                  multiple
                  :limit="999"
                  action=""
                  :disabled="disabled"
                  :http-request="httpRequest"
                  :on-remove="handleRemove"
                  :headers="headers"
                  :file-list="fileList"
                  :on-success="handleSuccess"
                  :before-upload="beforeUpload"
                >
                  <el-button slot="trigger" size="small" type="primary" @click="importFile">选取文件</el-button>
                  <el-button
                    style="margin-left: 10px"
                    v-loading.fullscreen.lock="fjLoading"
                    element-loading-text="数据导入中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    size="small"
                    type="success"
                    @click="checkFormValid"
                    >上传
                  </el-button>
                  <el-button type="text" style="color: red" size="mini" @click="clearFile">一键清空</el-button>
                  <div slot="tip" class="el-upload__tip">请先选择“产品文件夹”，系统将根据产品自动匹配"上传类型”只能上传图片文件，可批量上传</div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="text-align: center">
          <el-button @click="onCancelImport" size="medium">取 消</el-button>
        </div>
      </div>
    </q-dialog>
    <!-- 模型上传 -->
    <q-dialog :visible="isVisibleModelImport" title="模型上传" width="780px" :innerScroll="false" :showFooter="false" @cancel="onCancelModelImport" @close="onCancelModelImport">
      <div v-loading="loading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading">
        <el-form :model="requestParamModel" :rules="rulesModel" ref="requestParamModel" label-width="140px" class="content">
          <el-row>
            <!-- 模型图 -->
            <el-col :span="24" align="left">
              <el-form-item label="上传类型" prop="uploadType">
                <el-select v-model="requestParamModel.uploadType" size="mini">
                  <el-option label="普通" value="普通"></el-option>
                  <el-option label="京东" value="京东"></el-option>
                  <el-option label="天猫" value="天猫"></el-option>
                  <el-option label="其他" value="其他"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="模型文件:">
                <el-upload
                  class="upload-demo"
                  accept=".jpg,.jpeg,.png"
                  ref="uploadModel"
                  multiple
                  :limit="999"
                  action=""
                  :disabled="disabledModel"
                  :http-request="httpRequest"
                  :on-remove="handleRemoveModel"
                  :headers="headers"
                  :file-list="fileListModel"
                  :on-success="handleSuccess"
                  :before-upload="beforeUploadModel"
                >
                  <el-button slot="trigger" size="small" type="primary" @click="importFileModel">选取文件</el-button>
                  <el-button
                    style="margin-left: 10px"
                    v-loading.fullscreen.lock="fjLoading"
                    element-loading-text="数据导入中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    size="small"
                    type="success"
                    @click="checkFormValidModel"
                    >上传
                  </el-button>
                  <el-button type="text" style="color: red" size="mini" @click="clearFileModel">一键清空</el-button>
                  <div slot="tip" class="el-upload__tip">需先上传“渲染图”文件夹后才可上传“模型文件”，“模型”文件夹内需包含一张“模型图片”和“模型”压缩包文件</div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="text-align: center">
          <el-button @click="onCancelModelImport" size="medium">取 消</el-button>
        </div>
      </div>
    </q-dialog>
    <!-- 需上传渲染产品 -->
    <q-dialog :visible="isVisibleImportProduct" title="需上传渲染产品" width="50%" :innerScroll="false" :showFooter="false" @close="onCancelImportProduct">
      <div v-loading="loading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading">
        <el-table :data="productList" :span-method="objectSpanMethod" border highlight-current-row height="320" style="width: 100%">
          <el-table-column prop="productName" label="产品名称" min-width="220" show-overflow-tooltip> </el-table-column>
          <!-- <el-table-column prop="skuName" label="涉及SKU名称" show-overflow-tooltip> </el-table-column> -->
          <el-table-column prop="processType" label="渲染类型" width="100"> </el-table-column>
          <el-table-column prop="businessType" label="上传类型" width="120"> </el-table-column>
          <el-table-column prop="upload" label="是否上传" width="100"> </el-table-column>
        </el-table>
        <div style="text-align: center; margin-top: 20px">
          <el-button @click="onCancelImportProduct" size="medium">取 消</el-button>
        </div>
      </div>
    </q-dialog>
  </div>
</template>

<script>
import moment from 'moment';
import { getToken } from '@/utils/auth';
import axios from '@/utils/axiosInstance';
export default {
  name: 'up',
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    spuId: [String, Number],
    //渲染所有sku是否全部上传
    renderImportShow: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    title() {
      return '渲染';
    },
    //判断所有文件是否上传完毕
    allFilesVerified() {
      return this.fileListAll.length && this.fileList.length && this.fileListAll.length === this.fileList.length;
    },
    //获取顶层文件夹名
    topLevelName() {
      if (this.allFilesVerified) {
        var str = this.fileList[0].webkitRelativePath;
        var index = str.indexOf('/');
        var topLevelName = str.substring(0, index);
        return topLevelName;
      } else {
        return '';
      }
    },
    //该文件夹是否为首次上传
    isFirst() {
      if (this.allFilesVerified) {
        let fileNameList = this.tableData.map((v) => v.convertProductName);
        let topLevelName = this.topLevelName + '(渲染)';
        let isFirst = !fileNameList.includes(topLevelName);
        if (isFirst) {
          this.$set(this.requestParam, 'businessType', 1);
        } else {
          this.$set(this.requestParam, 'businessType', '');
        }
        return isFirst;
      } else {
        this.$set(this.requestParam, 'businessType', '');
        return false;
      }
    },
  },
  data() {
    return {
      loading: false,
      isVisibleImport: false,
      isVisibleModelImport: false,
      isVisibleImportProduct: false,
      addForm: {
        dataType: 2,
      },
      tableData: [],
      rules: {},
      addForm: {},
      storeList: [],
      tableReload: true,
      onRemoveSpuIds: [],
      selectSpus: [],
      money: 0,
      requestParam: {},
      requestParamModel: {},
      rules: {
        businessType: [{ required: true, message: '不能为空', trigger: 'change' }],
        modelFlag: [{ required: true, message: '不能为空', trigger: 'change' }],
      },
      rulesModel: {
        uploadType: [{ required: true, message: '不能为空', trigger: 'change' }],
      },
      headers: {
        Authorization: getToken(),
      },
      fileList: [],
      fileListModel: [],
      fileListAll: [],
      fileListAllModel: [],
      fjLoading: false,
      errorType: false,
      errorTypeModel: false,
      errorTypeModelModel: false,
      disabled: false,
      disabledModel: false,
      processType: 2,
      productList: [],
      //合并表格
      columnArr: ['productName', '', 'businessType', 'upload'],
      spanArr: [], //临时组
      spanData: [], // 组合的合并组
    };
  },
  mounted() {
    this.auditOrderInfo();
    this.queryRenderingUploadProduct();
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    onCancelImport() {
      this.isVisibleImport = false;
      this.fileList = [];
      this.fileListAll = [];
    },
    onCancelImportProduct() {
      this.isVisibleImportProduct = false;
    },
    onCancelModelImport() {
      this.isVisibleModelImport = false;
      this.requestParamModel.uploadType = ''
      this.$nextTick(_=>{
        this.$refs.requestParamModel.clearValidate('uploadType');
      })
      this.fileListModel = [];
      this.fileListAllModel = [];
    },
    //获取需上传产品信息
    async queryRenderingUploadProduct() {
      const params = {
        spuId: this.spuId,
      };
      let res = await this.$q.newProduct.queryRenderingUploadProduct({ params });
      this.productList = res.data;
    },
    getProductList() {
      this.isVisibleImportProduct = true;
      this.getSpanData(this.productList);
    },
    // 计算需要合并的单元格
    getSpanData(data) {
      this.spanData = [];
      this.columnArr.forEach((element) => {
        let contactDot = 0;
        this.spanArr = [];
        data.forEach((item, index) => {
          if (index === 0) {
            this.spanArr.push(1);
          } else {
            if (item[element] === data[index - 1][element]) {
              this.spanArr[contactDot] += 1;
              this.spanArr.push(0);
            } else {
              contactDot = index;
              this.spanArr.push(1);
            }
          }
        });
        this.spanData.push(this.spanArr);
      });
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (this.columnArr.includes(column.property)) {
        if (this.spanData[columnIndex][rowIndex]) {
          return {
            rowspan: this.spanData[columnIndex][rowIndex],
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    confirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
      });
    },
    importRender() {
      this.isVisibleImport = true;
      this.$nextTick(() => {
        this.$refs.upload.$children[0].$refs.input.webkitdirectory = true;
      });
    },
    importModel() {
      this.isVisibleModelImport = true;
      this.$nextTick(() => {
        this.$refs.uploadModel.$children[0].$refs.input.webkitdirectory = true;
      });
    },
    download(row) {
      let _this = this;
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      const data = {
        processType: this.processType,
        productName: row.productName,
        spuId: this.spuId,
      };
      this.$q.newProduct.pictureDownload({ data: data }).then((res) => {
        console.log(res);
        var timer = setInterval(function () {
          _this.$q.common
            .reportTaskInfo({ fragment: [res.message] })
            .then((res) => {
              if (res.data.taskStatus == '执行完成') {
                clearInterval(timer);
                loading.close();
                _this.downloadRes(res.data.filePath, row.productName);
              }
            })
            .catch((err) => {
              loading.close();
              this.$message.error(err.message);
            });
        }, 5000);
      });
    },
    async downloadRes(url, fileName) {
      let response = await fetch(url, { mode: 'cors' });
      let blob = await response.blob();
      let objectUrl = window.URL.createObjectURL(blob);
      let a = document.createElement('a');
      a.href = objectUrl;
      a.download = fileName + '' + url.substring(url.lastIndexOf('.'));
      a.click();
      a.remove();
    },
    auditOrderInfo() {
      this.loading = true;
      axios
        .get(`/ec-goods-new-api/newProductArrival/picture/uploadHis/${this.spuId}/${this.processType}`)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    importFile(event) {
      if (this.fileList.length) {
        this.$message.error(`一次仅上传一个${this.title}文件夹`);
        this.disabled = true;
        setTimeout(() => {
          this.disabled = false;
        }, 20);
        return;
      }
      this.errorType = false;
    },

    handleRemove(file, fileList) {
      if (this.errorType) {
        this.fileList = [];
        return;
      }
      this.fileList = fileList;
    },
    httpRequest(file) {},
    handleSuccess(res, file) {
      if (res.code === 200) {
        this.$message.success(res.message);
      } else {
        this.$message.error(res.message);
      }
      this.onCancel();
    },
    // 验证
    beforeUpload(file) {
      // console.log(file);
      // console.log(this.fileList);
      let pattern = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
      //判断文件夹类型 取第二层的文件夹
      let twoFileName = file.webkitRelativePath.split('/')[1];
      if (pattern != 'db' && pattern != 'ds_store') {
        //排除隐藏.db系统文件
        this.fileListAll.push(file);
      }
      if (this.errorType) {
        this.fileList = [];
        return;
      }
      if (
        pattern != 'jpg' &&
        pattern != 'db' &&
        pattern != 'ds_store' &&
        (twoFileName.includes('大片') || twoFileName.includes('小片') || twoFileName.includes('特写'))
      ) {
        this.errorType = true;
        this.$message.error('大片、小片、特写上传图片只能是jpg格式!');
        return false;
      } else if (pattern != 'png' && pattern != 'db' && pattern != 'ds_store' && twoFileName.includes('退底')) {
        this.errorType = true;
        this.$message.error('退底上传图片只能是png格式!');
        return false;
      } else if (pattern != 'png' && pattern != 'jpg' && pattern != 'db' && pattern != 'ds_store' && twoFileName.includes('通道')) {
        this.errorType = true;
        this.$message.error('通道上传图片只能是png、jpg格式!');
        return false;
      }
      if (!this.errorType && pattern != 'db' && pattern != 'ds_store') {
        this.fileList.push(file);
      }
    },
    checkFormValid(file) {
      this.$refs['requestParam'].validate((valid) => {
        if (valid) {
          this.submitUpload(file);
        } else {
          this.$message.error('参数校验失败！');
        }
      });
    },
    clearFile() {
      this.fileListAll = [];
      this.fileList = [];
    },
    submitUpload(file) {
      if (!this.fileList || this.fileList.length === 0) {
        this.$message.error('请先上传图片');
        return;
      }
      const form = new FormData();
      const _this = this;
      var pathInfo = [];
      var secondaryFileName = [];
      var secondaryFileNameAll = ['大片', '小片', '特写', '退底', '通道'];
      form.append('topFolderName', this.topLevelName);
      form.append('spuId', this.spuId);
      form.append('businessType', this.requestParam.businessType);
      form.append('processType', this.processType);
      this.fileList.forEach((v) => {
        form.append('files', v);
        pathInfo.push({
          fileFullPath: v.webkitRelativePath,
          fileName: v.name,
        });
        if ((v.webkitRelativePath.match(new RegExp('/', 'g')) || []).length > 1 && !v.webkitRelativePath.includes('ds_store')) {
          secondaryFileName.push(v.webkitRelativePath.match(/\/(.*?)\//)[1].trim());
        }
      });
      form.append('pathInfo', JSON.stringify(pathInfo));
      if (!secondaryFileName.length) {
        this.$message.error('请确认文件夹上传规范是否正确！');
        return;
      }
      console.log(this.isFirst);
      if (!secondaryFileNameAll.some((item) => secondaryFileName.includes(item)) && this.isFirst) {
        this.$message.error(`请确认图片是否上传！`);
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: '图片上传中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)',
      });
      this.$q.newProduct
        .batchUploadProductPicture({ data: form })
        .then((res) => {
          if (res.code == 200 && res.data) {
            var timer = setInterval(function () {
              _this.$q.common
                .reportTaskInfo({ fragment: [res.data] })
                .then((res) => {
                  if (res.data.taskStatus == '执行完成') {
                    clearInterval(timer);
                    loading.close();
                    if (res.data.taskResult == '成功') {
                      _this.secondaryConfirmation();
                    } else {
                      _this.onCancelImport();
                      _this.$message.error(res.data.failReason);
                    }
                  }
                })
                .catch((err) => {
                  loading.close();
                  this.$message.error(err.message);
                });
            }, 5000);
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((_) => {
          loading.close();
        });
    },
    //当维护了拍摄类型 渲染上传后会判断是否需要二次上传 需要则可以继续进行上传 不要就完成该节点 调用完成渲染接口
    secondaryConfirmation() {
      this.$message.success('上传成功');
      this.loading = true;
      this.$q.newProduct.retouchQuerySkuFinish({ data: { spuId: this.spuId, taskId: 111 } }).then(({ data }) => {
        if (data.length) {
          this.$confirm(
            '已成功上传渲染，同时涉及SKU的渲染节点将自动完成是否完成节点?完成后，除“回退”操作外无法修改"渲染”内容;<br>如还需修改“渲染”内容，请点击“继续上传”。',
            '提示',
            {
              confirmButtonText: '完成节点',
              cancelButtonText: '继续上传',
              confirmButtonClass: 'orange-btn',
              cancelButtonClass: 'green-btn',
              closeOnClickModal: false,
              dangerouslyUseHTMLString: true,
              customClass: 'my-dialog',
            }
          )
            .then(() => {
              this.completeRendering(data);
            })
            .catch(() => {
              this.auditOrderInfo();
              this.clearFile();
            });
        } else {
          this.isVisible = false;
          this.$emit('success');
        }
        this.loading = false;
      });
    },
    //完成渲染
    completeRendering(skuIdList) {
      this.loading = true;
      const data = skuIdList.map((v) => {
        return {
          spuId: this.spuId,
          skuId: v,
        };
      });
      this.$q.newProduct
        .completeRendering({ data: data })
        .then(({ success }) => {
          if (success) {
            this.$notify.success({
              title: '成功',
              message: `完成渲染成功`,
            });
          }
        })
        .finally((_) => {
          //不管成功还是失败 都刷新页面
          this.isVisible = false;
          this.loading = false;
          this.$emit('success');
        });
    },


    //模型图上传
    importFileModel() {
      if (this.fileListModel.length) {
        this.$message.error(`一次仅上传一个模型文件夹`);
        this.disabledModel = true;
        setTimeout(() => {
          this.disabledModel = false;
        }, 20);
        return;
      }
      this.errorTypeModelModel  = false;
    },
    handleRemoveModel(file, fileList) {
      if (this.errorTypeModelModel) {
        this.fileListModel = [];
        return;
      }
      this.fileListModel = fileList;
    },
    // 验证
    beforeUploadModel(file) {
      let pattern = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
      if (pattern != 'db' && pattern != 'ds_store') {
        //排除隐藏.db系统文件
        this.fileListAllModel.push(file);
      }
      if (this.errorTypeModelModel) {
        this.fileListModel = [];
        return;
      }
      if (!this.errorTypeModelModel && pattern != 'db' && pattern != 'ds_store') {
        this.fileListModel.push(file);
      }
    },
    checkFormValidModel(file) {
      this.$refs['requestParamModel'].validate((valid) => {
        if (valid) {
          this.submitUploadModel(file);
        } else {
          this.$message.error('参数校验失败！');
        }
      });
    },
    clearFileModel() {
      this.fileListAllModel = [];
      this.fileListModel = [];
    },
    submitUploadModel(file) {
      if (!this.fileListModel || this.fileListModel.length === 0) {
        this.$message.error('请先上传模型文件');
        return;
      }
      const form = new FormData();
      form.append('spuId', this.spuId);
      form.append('uploadType', this.requestParamModel.uploadType);
      const _this = this;
      var zipErro = [];
      var imgErro = [];
      this.fileListModel.forEach((v) => {
        let pattern = v.name.substring(v.name.lastIndexOf('.') + 1).toLowerCase();
        form.append('files', v);
        if(['zip','rar','7z','tar','gz','tgz','bz2','xz','tbz2','tbz','txz','tb2','tbz2','tx2'].includes(pattern) ) {
          zipErro.push(1)
        }
        if(['png','jpg','jpeg','gif','bmp','svg'].includes(pattern)) {
          console.log(pattern);
          imgErro.push(1)
        }
      });
      if (!zipErro.length || !imgErro.length) {
        this.$message.error('请确认文件夹上传规范是否正确');
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: '图片上传中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)',
      });
      this.$q.newProduct
        .productModelrRenderBatchUpload({ data: form })
        .then((res) => {
          if (res.code == 200 && res.data) {
            var timer = setInterval(function () {
              _this.$q.common
                .reportTaskInfo({ fragment: [res.data] })
                .then((res) => {
                  if (res.data.taskStatus == '执行完成') {
                    clearInterval(timer);
                    loading.close();
                    if (res.data.taskResult == '成功') {
                      _this.$message.success('上传成功');
                      _this.isVisible = false;
                      _this.$emit('complete');
                    } else {
                      _this.onCancelImport();
                      _this.$message.error(res.data.failReason);
                    }
                  }
                })
                .catch((err) => {
                  loading.close();
                  this.$message.error(err.message);
                });
            }, 5000);
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((_) => {
          loading.close();
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px
}

.right50 {
  margin-right: 50px;
}

.content {
  padding: 20px;
  max-height: 70vh;
  overflow-y: auto;
}

.footer {
  margin: 15px 0 5px 0;
  text-align: center
}

>>> .el-form-item{
  margin-bottom: 16px
}

>>> .el-upload-list {
  max-height: 50vh
  overflow-y: auto
}
>>> .el-dialog {
  margin-top: 50px !important
}
</style>
<style lang="css">
.my-dialog {
  border: 0px !important;
}
.my-dialog .el-message-box__header {
  background: #24c69a;
}
.my-dialog .el-message-box__title {
  color: #fff;
}
.my-dialog .el-message-box__headerbtn .el-message-box__close {
  color: #fff;
}
.my-dialog .el-message-box__btns {
  text-align: center;
}
</style>
